import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import React, { useState } from "react";
import clsx from "clsx";

interface BaseCardProps {
  title: string | { whenExpanded: string; whenCollapsed: string };
  subtitle?: string;
  children: React.ReactNode;
  rightAdornment?: React.ReactNode;
  expandable?: boolean;
  initiallyExpanded?: boolean;
}

export function BaseCard({ title, subtitle, children, rightAdornment, expandable = false, initiallyExpanded = false }: BaseCardProps) {
  const [expanded, setExpanded] = useState(expandable ? initiallyExpanded : true);

  return <div className="rounded-lg bg-white border p-4">
    <div className={clsx('flex justify-between items-center pb-2 border-b', expanded && 'mb-4')}>
      <div>
        <h3 className="font-semibold text-base text-gray-900">
          {
            typeof title === "string" ?
              title
              : (expanded ? title.whenExpanded : title.whenCollapsed)
          }
        </h3>
        {subtitle && <p className="text-sm text-gray-700">{subtitle}</p>}
      </div>
      <div className="flex flex-row items-center space-x-4">
        {rightAdornment ?? <></>}
      {expandable && (
        <div>
          <button type="button" onClick={() => setExpanded(!expanded)} className="text-sm text-gray-500">
            {expanded ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
          </button>
        </div>
      )}
      </div>  
    </div>
    {expanded && children}
  </div>
}